import React from "react";
import {geoTransform} from "d3-geo";
import {geoPath} from "d3-geo";
import * as d3 from "d3"
import mapboxgl from "mapbox-gl"
import Detail from './Detail';
import Navigation from  './Navigation';
import SearchBox from './SearchBox';
import Loading from './Loading';

mapboxgl.accessToken = "pk.eyJ1IjoibWlsbGU5MSIsImEiOiJjazBuczFiemUwMndsM2VydWJzaDh3dGNuIn0.5Ac6-Du_lEIqpDOINjeaVw";

class Basemap extends React.Component {

  constructor(props: Props) {
    super(props);

    this.state = {
      isLoading: true,
      // data
      map: null,
      clubs: {},
      lawplans: null,
      sanierung: null,
      planziele: null,

      layers: [],
      venues: [],
      detailVisibility:   "hidden",
      venuesVisibility:   "hidden",
      bezirkVisibility:   "hidden",
      layersVisibility:   "hidden",
      mapThemeVisibility: "hidden",

      // detail states
      type: "",
      club_id: "",
      name: "",
      address: "",
      bezirk: "",
      masterBezirk:[],
      status: "",
      reason: "",
      nutzung: "",
      first_date: "",
      last_date: "",
      sanierung_info:"",
      old_bplan_name: "",
      coordinates: null,
      x: null,
      y: null,
      searchResult: null
    };

  }

  componentDidMount() {

    var onD3Click = this.onD3Click;

    var map = new mapboxgl.Map({
      container: this.mapContainer,
      style: "mapbox://styles/mapbox/dark-v10", // dark default
      center: [13.401422, 52.521749],
      zoom: 11
    });

    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();
    map.addControl(new mapboxgl.NavigationControl());

    const canvas = map.getCanvasContainer();
    const svg = d3.select(canvas).append("svg");

    var lawPlan = svg.append("g").attr("id", "lawplanSvg");
    var sanierungsGebiet = svg.append("g").attr("id", "sanierungSvg").style("visibility", "hidden" );
    var planzielGebiet = svg.append("g").attr("id", "planzielSvg").style("visibility", "hidden" );
    var clubCircles = svg.append("g").attr("id", "clubSvg");


    Promise.all([
      fetch("/clubs").then(response => response.json()),
      fetch("/sanierung").then(response => response.json()),
      fetch("/lawplans").then(response => response.json()),
      fetch("/planziele").then(response => response.json())
      ]).then(allResponses => {
    

        const clubs = allResponses[0][0].jsonb_build_object
        const sanierung = allResponses[1][0].jsonb_build_object
        const lawplans = allResponses[2][0].jsonb_build_object
        const planziele = allResponses[3][0].jsonb_build_object
        console.log(clubs)

        this.setState({ sanierung: sanierung,
                        clubs: clubs,
                        lawplans: lawplans,
                        planziele: planziele,
                        isLoading:false})

        if (sanierung.features !== null) {

          drawElement(this.state.sanierung, sanierungsGebiet, "path", "sanierung" )
        }

        if (lawplans.features !== null) {
          drawElement(this.state.lawplans, lawPlan, "path", "lawplan")
        }
        drawElement(this.state.planziele, planzielGebiet, "path", "planziele" )
        drawElement(this.state.clubs, clubCircles, "circle", "club" )


        clubCircles.selectAll("circle").each(club);

          clubCircles.selectAll("circle").each(club);

          function club(d) {
        
            const status = d.properties.situation.split("-")[0].trim()
            if (status === "0") {
              d3.select(this).attr("class", "alert-level-0");
            }

            else {
              d3.select(this).attr("class", "alert-level-" + status)
            }

            if(d.properties.url !== null){
              d3.select(this).attr("data", "warning")
            }

          }

        this.updateMap(map)

    })
    .catch(error => console.log(error))

    function drawElement(data, svgElement, svgType, dataType) {


      svgElement.selectAll(svgType)
        .data(data.features)
        .enter().append(svgType)
        .attr("r", 5) // TODO: only set r attribute on circles
        .on("click", function(d) { onD3Click(d, dataType,this)
        })
    }

    map.on("viewreset", this.updateMap);
    map.on("move",      this.updateMap);
    map.on("moveend",   this.updateMap);
    this.setState({map});

  }

  componentDidUpdate(prevProps){
    // TODO: compare prevprops with this.props
    this.draw(this.props,this.state,this.onD3Click)
  }

  setLayers = (dataFromLayers) => {
    this.setState({ layers: dataFromLayers });
  }
  setVenues = (dataFromVenues) => {

    this.setState({ venues: dataFromVenues.venues , venues_2: dataFromVenues.venues_2,venues_3: dataFromVenues.venues_3});
  }
  setBezirk = (dataFromBezirk) => {

    this.setState({ bezirk: dataFromBezirk.bezirk});

  }

  hideAll = () => {
    this.setState({
      bezirkVisibility:   "hidden",
      venuesVisibility:   "hidden",
      detailVisibility:   "hidden",
      layersVisibility:   "hidden",
      mapThemeVisibility: "hidden"
    })
  }

  toggleLayers = (dataFromNavigation) => {
    this.hideAll();
    this.setState({club_id: "", name:""})
    this.setState({layersVisibility: this.state.layersVisibility === "visible" ? "hidden" : "visible" });
  }

  toggleVenues = (dataFromNavigation) => {
    this.hideAll();
    this.setState({club_id: "", name:""})
    this.setState({venuesVisibility: this.state.venuesVisibility === "visible" ? "hidden" : "visible" });
  }
  toggleBezirk = (dataFromNavigation) => {
    this.hideAll();
    this.setState({club_id: "", name:""})
    this.setState({bezirkVisibility: this.state.bezirkVisibility === "visible" ? "hidden" : "visible" });
  }
  toggleMapTheme = (dataFromNavigation) => {
    this.hideAll();
    this.setState({club_id: "", name:""})
    this.setState({mapThemeVisibility: this.state.mapThemeVisibility === "visible" ? "hidden" : "visible" });
  }

  closeDetail = () => {
    d3.select("#clubSvg").selectAll("circle").attr("stroke", "none")
    this.setState({
      detailVisibility: "hidden",
      club_id: "",
      name: "",
    });
  }

  clearDetail = () => {
    this.setState({
      type: "",
      name: "",
      address: "",
      status: "",
      reason: "",
      nutzung: "",
      first_date: "",
      last_date: ""
    });
  }

  setMapTheme = (style) => {
    let map = this.state.map;
    map.setStyle(style)
    this.setState({map})
  }

  unproject = (d) => {
    const tmpMap = this.state.map
    const t = tmpMap.unproject(d)
    return [t.lng,t.lat];
  }

  updateMap = (basemap) => {

      var tmpMap;
      if (this.state.map === null) {
        tmpMap = basemap;
      }
      else {
        tmpMap = this.state.map
      }

      function project(d) {
        return tmpMap.project(new mapboxgl.LngLat(+d[0], +d[1]));
      }

      function projectPoint(lon, lat) {
        var point = tmpMap.project(new mapboxgl.LngLat(lon, lat));
        this.stream.point(point.x, point.y);
      }

      var transform = geoTransform({point:projectPoint});
      var geopath = geoPath().projection(transform);

      d3.select("#lawplanSvg").selectAll("path")
        .attr( "d", geoPath().projection(transform));

      d3.select("#clubSvg").selectAll("circle")
        .attr("cx", function(d) { return project(d.geometry.coordinates).x })
        .attr("cy", function(d) { return project(d.geometry.coordinates).y });

      d3.select("#sanierungSvg").selectAll("path")
        .attr( "d", geopath);


      d3.select("#planzielSvg").selectAll("path")
        .attr( "d", geopath);

      if (this.state.coordinates !== null) {
        var tooltipCoords = project(this.state.coordinates);
        var xCoord = Math.round(tooltipCoords.x);
        var yCoord = Math.round(tooltipCoords.y);

        this.setState({x:xCoord + 10, y: yCoord +10 })
      }

   }

  focusMap = (searchResult) => {

    const tmpMap = this.state.map;
    this.setState({searchResult: searchResult});
    tmpMap.flyTo({
          center: [searchResult[0],searchResult[1]],
          zoom:18,
          essential: true 
    });
     
  }

  onD3Click = (info, type, that) => {

    d3.select("#clubSvg").selectAll("circle").attr("stroke", "none")
    d3.select(that).attr("stroke", "white")

    this.clearDetail();
    this.hideAll();



    switch(type) {

      case "club":

        var bplan_name = info.properties.current_bplan_name;
        var bplan_url = info.properties.url;

        if(info.properties.current_bplan_name){

           bplan_name = info.properties.current_bplan_name.split(',')
           bplan_url = info.properties.url.split(',')
          }


        this.setState({
          detailVisibility: "visible",
          type: "club",
          venue_type: info.properties.venue_type,
          club_id: info.properties.uuid,
          name: info.properties.name,
          address: info.properties.strasse +", "+ info.properties.bezirk,
          status: info.properties.situation.split("-")[0].trim(),
          reason: info.properties.situation,
          sanierung_id: info.properties.sanierung_id , /* TODO: undefined */
          nutzung: "Flächennutzung: "+ info.properties.nutzung , /* TODO: undefined */
          start_date: info.properties.start_date,
          last_date: info.properties.last_date,
          url: bplan_url,
          current_bplan_name: bplan_name,
          old_bplan_name: info.properties.old_bplan_name,
          coordinates: info.geometry.coordinates,
          x: d3.event.pageX + 10 + "px",
          y: d3.event.pageY + 10 + "px"
        });
        break;

      case "lawplan":
        this.setState({
          detailVisibility: "visible",
          type: "lawplan",
          url: info.properties.url,
          name: info.properties.current_bplan_name,
          auslegung: info.properties.aul_anfang + " - " + info.properties.aul_ende ,
          beteiligung: info.properties.bbg_anfang + " - " + info.properties.bbg_ende,
          beschluss: info.properties.afs_beschl,
          behoerde: info.properties.afs_behoer + " " + info.properties.bezirk,
          coordinates: this.unproject({x:d3.event.pageX,y:d3.event.pageY}),
          x: d3.event.pageX + 10 + "px",
          y: d3.event.pageY + 10 + "px"
        });
        break;

      case "sanierung":
        this.setState({
          detailVisibility: "visible",
          type: "sanierung",
          id: info.properties.sanierung_id,
          name: info.properties.sanierung_name,
          coordinates: this.unproject({x:d3.event.pageX,y:d3.event.pageY}),
          x: d3.event.pageX + 10 + "px",
          y: d3.event.pageY + 10 + "px"
        });
        break;

      case "planziele":
        this.setState({
          detailVisibility: "visible",
          type: "planziele",
          planziel_name: info.properties.planziel_name,
          coordinates: this.unproject({x:d3.event.pageX,y:d3.event.pageY}),
          x: d3.event.pageX + 10 + "px",
          y: d3.event.pageY + 10 + "px"
        });
        break;
      default:
        break;
    }


  }


  draw = (props, state, onD3Click) => {

//if bezirk is checked -> hide all and only toggle the the ones within the visible bezirk

    d3.select("#clubSvg").selectAll("circle")
        .style("visibility", "hidden" )

    d3.select("#sanierungSvg").selectAll("path")
    .style("visibility", "hidden" )

    d3.select("#planzielSvg").selectAll("path")
    .style("visibility", "hidden" )

    let venues = [].concat(...this.state.venues,this.state.venues_2,this.state.venues_3);

    //let venues = this.state.venues;
    let layers = this.state.layers;

    for (const bezirk of this.state.bezirk) {

      if (bezirk.id === "mitte") {

         toggleHelperBezirk(bezirk.name)

        if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }

       }

      else if (bezirk.id === "kreuzberg") {
        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "pankow") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "charlottenburg") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "spandau") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "stegliz") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "tempelhof") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
       else if (bezirk.id === "neukolln") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "treptow") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "marzahn") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "lichtenberg") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }
      else if (bezirk.id === "reinickendorf") {

        toggleHelperBezirk(bezirk.name)

         if (bezirk.checked) {
          toggleVenues(venues,bezirk.name)
          toggleLayers(layers,bezirk.name)
        }
      }


      function toggleHelperBezirk(bezirk_name) {

        d3.select("#clubSvg").selectAll("circle")
        .filter(function(d, i) {return  d.properties.bezirk === bezirk_name})
        .style("visibility", function (d) {
              return bezirk.checked ? "visible" : "hidden";}
        )
      }

    }



    function toggleLayers(layers,bezirk) {

      for (const layer of layers) {
        if (layer.id === 0) {
          d3.select("#clubSvg").attr("class", () => {
            return layer.checked ? "visible" : "hidden";}
          );
        }
        else if (layer.id === 1) {
          d3.select("#lawplanSvg").attr("class", () => {
            return layer.checked ? "visible" : "hidden";}
          );
        }
        else if (layer.id === 'cc') {

          if (layer.checked) {
            d3.select("#clubSvg").selectAll("circle")
            .filter(function(d, i) {return  d.properties.cc !== "x" &&  d.properties.bezirk === bezirk})
            .style("visibility", function (d) {
                return !layer.checked ? "visible" : "hidden";}
            )
          }

        }
        else if  (layer.id === 2) {

           d3.select("#sanierungSvg").selectAll("path")
          .filter(function(d, i) {return   d.properties.bezirk === bezirk})
          .style("visibility", function (d) {
                return layer.checked ? "visible" : "hidden";})
        }
        else if  (layer.id === 'planziele') {

           d3.select("#planzielSvg").selectAll("path")
          .filter(function(d, i) {return   d.properties.bezirk === bezirk})
          .style("visibility", function (d) {
                return layer.checked ? "visible" : "hidden";})
        }
        if (layer.id === 4) {

          d3.select("#clubSvg")
          .classed("status-active", () => {
            return layer.checked ? true : false;}
          );
        }
      }
    }

    function toggleVenues(venues,bezirk) {

      for (const layer of venues) {
         //console.log(layer)

        if (layer.id === "all_venues") {

        }
        else if (layer.id === "club") {
          toggleHelper("Club")
        }
        else if (layer.id === "music_bar") {
          toggleHelper("Music Bar")
        }
        else if (layer.id === "disco") {
          toggleHelper("Disco")
        }
        else if (layer.id === "gallery") {
           toggleHelper("Gallery")
        }
        else if (layer.id === "sc_center") {
           toggleHelper("Sociocultural Center")
        }
        else if (layer.id === "dance_ballroom") {
           toggleHelper("Dance/Ballroom")
        }
        else if (layer.id === "arena_stadium") {
          toggleHelper("Arena/Stadium")
        }
        else if (layer.id === "concert_hall") {
          toggleHelper("Concert Hall/Livehouse")
        }
        else if (layer.id === "cinema") {
          toggleHelper("Cinema")
        }
        else if (layer.id === "prod_studio") {
          toggleHelper("Production Studio/CoWorking")
        }
        else if (layer.id === "retail_store") {
          toggleHelper("Retail Store/Shop")
        }
        else if (layer.id === "outdoor_stage") {
          toggleHelper("Outdoor stage")
        }
        else if (layer.id === "rental_venue") {
          toggleHelper("Rental venue/warehouse")
        }
        else if (layer.id === "cafe") {
          toggleHelper("Restaurant/Cafe")
        }
        else if (layer.id === "theater") {
          toggleHelper("Theater")
        }

        function toggleHelper(venueType) {
          d3.select("#clubSvg").selectAll("circle")
          .filter(function(d, i) {return d.properties.venue_type === venueType && d.properties.bezirk === bezirk})
          .style("visibility", function (d) {
                return layer.checked ? "visible" : "hidden";}
          )
        }

      }
    }

  }



  render() {
    const isLoading = this.state.isLoading;
    const clubFeatures = [this.state.clubs.features];
   
   /* const masterBezirk = this.state.masterBezirk
    console.log( masterBezirk[0])*/
    return (
      <div className="fullscreen">
        {isLoading ? <Loading/> : 
         <div>
         <SearchBox clubs={this.state.clubs} searchResult ={this.focusMap} />

         <Navigation visibility={this.state.layersVisibility}
                    venuesVisibility={this.state.venuesVisibility}
                    bezirkVisibility={this.state.bezirkVisibility}
                    mapThemeVisibility={this.state.mapThemeVisibility}
                    toggleLayers={this.toggleLayers}
                    toggleVenues={this.toggleVenues}
                    toggleBezirk={this.toggleBezirk}
                    toggleMapTheme={this.toggleMapTheme}
                    setLayers={this.setLayers}
                    setVenues={this.setVenues}
                    setBezirk={this.setBezirk}
                    setMapTheme={this.setMapTheme} 
                    dataFromParent = {this.state.clubs}  />
        </div>
        }
        <Detail  visibility={this.state.detailVisibility} data={this.state} closeDetail={this.closeDetail} />
        <div className="logos"> 
            <div>
               <img src="/clubcommission-logo.png" alt="Clubcommision" width="170" />
            </div>
             <div>
             <img src="/agurban-logo.png" alt="AG.URBAN" width="150"  />
            </div>
             
        </div>  
        <div className="attribution"> 
             ©  <a href='https://www.stadtentwicklung.berlin.de/geoinformation/fis-broker/'  rel='noopener noreferrer' >Geoportal Berlin/Bebauungspläne & Sanierungsgebiete</a>  
             © <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> 
             © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> <strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong>
         </div>  
        <div ref={mapRef => this.mapContainer = mapRef} id="map" />
      </div>
    );
  }
}

export default Basemap
